"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var MaybeRenderHOC = function MaybeRenderHOC(_ref) {
  var shouldRender = _ref.shouldRender,
      children = _ref.children;

  if (shouldRender) {
    return _react.default.createElement("div", null, children);
  }

  return null;
};

MaybeRenderHOC.propTypes = {
  shouldRender: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node.isRequired
};
var _default = MaybeRenderHOC;
exports.default = _default;
module.exports = exports.default;